import React from "react";
import {
  Grid,
  Typography,
} from "@material-ui/core";
import styled from 'styled-components';
import { Link } from "react-router-dom";
import ArrowButtonLink from './ArrowButtonLink';
import SectionLineTitle from './SectionLineTitle';
import DynamicElement from 'shared/components/DynamicElement'
import { LazyLoadImage } from 'react-lazy-load-image-component';

const DiamondIcon = styled((props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="41.206" height="56.878" viewBox="0 0 41.206 56.878">
  <g id="icon_branding_decor_1" transform="translate(-952.03 -918.904)">
    <path id="Path_3313" d="M478.14 146.634l-5.069 25.694-4.783 2.658 4.785 2.66 5.047 25.672 5.068-25.685 4.764-2.647-4.759-2.643z" className="cls-1" transform="translate(484.771 772.367)" />
    <path id="Path_3314" d="M478.14 146.634l-5.069 25.694-4.783 2.658 4.785 2.66 5.047 25.672 5.068-25.685 4.764-2.647-4.759-2.643z" className="cls-1" transform="translate(504.254 772.367)" />
  </g>
</svg>)`
  .cls-1{
    fill:none;
    stroke:#b08f6e;
  }
`;

const DiamondSingleIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="86.998" height="245.043" viewBox="0 0 86.998 245.043">
  <path fill="none" stroke="#b08f6e" d="M510.847 146.634l-21.9 110.988-20.659 11.478 20.67 11.49 21.8 110.89 21.889-110.947 20.58-11.432-20.557-11.415z" transform="translate(-467.258 -146.537)" />
</svg>;


export const MainText = styled.div`
  font-family: MinionPro-Disp;
  font-size: 72px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #484f57;
  position: relative;
`;

const DescriptionText = styled.div`
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.88;
  letter-spacing: normal;
  color: #24272b;
`;

export const InfoSide = ({ size, sectionLineTitleStyle = {}, infoSideStyle = {}, bigTitle, smallTitle, smallImage, description, readMorePath, bigTitleStyle, diamondIconStyle={ position: 'absolute', right: 32, top: 0 }, descriptionStyle={}, descriptionXs, smallImageStyle={}, readMorePathStyle}) => (<Grid item
  style={{ minHeight: "100px", width: "100%", paddingLeft: 88, paddingTop: 0, paddingRight: 30, paddingBottom: 20, ...infoSideStyle }}
  xs={size}
>
  <div style={sectionLineTitleStyle} className="SectionLineTitleWrap">
    <SectionLineTitle>{smallTitle}</SectionLineTitle>
  </div>

  <MainText style={bigTitleStyle} className="MainText">
    {bigTitle}
    {smallImage &&
      <DiamondIcon style={diamondIconStyle} />
    }
  </MainText>

  <Grid container
    style={{ minHeight: "100px", width: "100%", padding: 0 }}
    spacing={0}
  >
    <Grid
      key={'description'}
      style={{ minHeight: "100px", width: "100%", padding: 10, paddingLeft: 0, paddingRight: smallImage ? 70 : 0, textAlign: 'left', ...descriptionStyle }}
      xs={descriptionXs ? descriptionXs : smallImage ? 8 : 12}
      item
    >
      <DescriptionText>
        {description}
        <br />
        {readMorePath &&
          <ArrowButtonLink to={readMorePath} label={'Read More'} style={readMorePathStyle} />
        }
      </DescriptionText>
    </Grid>

    {smallImage &&
      <Grid item
        key={'smallImage'}
        style={{ minHeight: "100px", width: "100%", padding: 30, ...smallImageStyle }}
        lg={4}
        sm={12}
        md={12}
        xs={12}
      >

        <DynamicElement id={smallImage}>
          {({ value }) =>
            <LazyLoadImage className="InfoSide-smallImage" style={{ maxWidth: "100%", height: 'auto' }} src={value} />
          }
        </DynamicElement>
      </Grid>
    }
  </Grid>
</Grid>);

export const BigImageSide = ({ size, bigImage, bigImage2, bigImage3, bigImageMaxWidth, bigImageSideStyle, diamondSingleIconStyle={}, bigImageStyle={}, bigImage2Style={}, bigImage3Style={}, bigImage2WrapperStyle={}, bigImage3WrapperStyle={}, bigImageWrapperStyle={} }) => (<Grid item
  style={{ minHeight: "100px", width: "100%", paddingTop: bigImage2 || bigImage3 ? '7%' : 5, paddingRight: bigImage2 || bigImage3 ? '5%' : 0, maxWidth: bigImageMaxWidth, position: 'relative', ...bigImageSideStyle }}
  xs={size}
>
  {(bigImage2 || bigImage3) &&
    <DiamondSingleIcon style={{ position: 'absolute', left: '10%', top: '-15%', width: 85, height: 244, ...diamondSingleIconStyle }} />
  }

  <DynamicElement id={bigImage} style={{ ...bigImageWrapperStyle }}>
    {({ value }) =>
      <LazyLoadImage className="BigImageSide-bigImage" style={{ maxWidth: "100%", height: 'auto', position: 'relative', ...bigImageStyle }} src={value} />
    }
  </DynamicElement>

  {bigImage2 &&
    <DynamicElement id={bigImage2} style={{ position: 'absolute', zIndex: 1, width: '35%', top: 0, right: 0, height: 'auto', ...bigImage2WrapperStyle }}>
      {({ value }) =>
        <LazyLoadImage className="BigImageSide-bigImage2" style={{ background: 'transparent', width: '100%', height: 'auto', ...bigImage2Style }} src={value} />
      }
    </DynamicElement>
  }

  {bigImage3 &&
    <DynamicElement id={bigImage3} style={{ position: 'absolute', zIndex: 1, width: '45%', bottom: 0, right: '-10%', height: 'auto', ...bigImage3WrapperStyle }}>
      {({ value }) =>
        <LazyLoadImage className="BigImageSide-bigImage3" style={{ background: 'transparent', width: '100%', height: 'auto', ...bigImage3Style }} src={value} />
      }
    </DynamicElement>
  }
</Grid>);

function SectionRowLayout(props) {
  const {
    bigImage, bigImage2, bigImage3, bigImageMaxWidth, smallTitle, bigTitle,
    description, smallImage, readMorePath, swapSides, infoSideStyle = {}, bigImageSideStyle = {},
    infoSize = 8, bigImageSize = 4, sectionLineTitleStyle,
  } = props;

  return (<div>
    <Grid
      style={{ minHeight: "100px", width: "100%" }}
      spacing={0}
      container
    >
      {!swapSides && <React.Fragment>
        <BigImageSide size={bigImageSize} bigImage={bigImage} bigImage2={bigImage2} bigImage3={bigImage3} bigImageMaxWidth={bigImageMaxWidth} bigImageSideStyle={bigImageSideStyle} />
        <InfoSide size={infoSize} sectionLineTitleStyle={sectionLineTitleStyle} infoSideStyle={infoSideStyle} bigTitle={bigTitle} smallTitle={smallTitle} smallImage={smallImage} description={description} readMorePath={readMorePath} />
      </React.Fragment>}

      {swapSides && <React.Fragment>
        <InfoSide size={infoSize} sectionLineTitleStyle={sectionLineTitleStyle} infoSideStyle={infoSideStyle} bigTitle={bigTitle} smallTitle={smallTitle} smallImage={smallImage} description={description} readMorePath={readMorePath} />
        <BigImageSide size={bigImageSize} bigImage={bigImage} bigImage2={bigImage2} bigImage3={bigImage3} bigImageMaxWidth={bigImageMaxWidth} bigImageSideStyle={bigImageSideStyle} />
      </React.Fragment>}
    </Grid>
  </div>);
}

export default SectionRowLayout;